import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { useMediaRecord } from "../../../../hooks";
import { MediaRecordStatus } from "../../../../view-model";
import { usePrevious } from '@isyc-react/core';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';
import "../../camera.style.scss";
export const CameraRecordButton = props => {
  const {
    stream,
    options,
    onRecord
  } = props;
  const [recorder, {
    record,
    status,
    error
  }] = useMediaRecord(stream, options);
  const previous = usePrevious(record);
  React.useEffect(() => {
    if (onRecord && record && record !== previous) onRecord(record);
  }, [record, onRecord]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, recorder && /*#__PURE__*/React.createElement(React.Fragment, null, status !== MediaRecordStatus.INACTIVE && /*#__PURE__*/React.createElement(RippleButton, {
    onClick: () => {
      if (status === MediaRecordStatus.PAUSED) recorder.resume();else recorder.pause();
    },
    className: "btn-media-camera action"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx('mdi', {
      'mdi-play': status === MediaRecordStatus.PAUSED,
      'mdi-pause': status === MediaRecordStatus.RECORDING
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "btn-media-camera-record"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    onClick: () => {
      if (status === MediaRecordStatus.INACTIVE) recorder.start();else recorder.stop();
    },
    className: "btn-media-camera action"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx('mdi', {
      'mdi-video': status === MediaRecordStatus.INACTIVE,
      'mdi-stop': status !== MediaRecordStatus.INACTIVE
    })
  })), status === MediaRecordStatus.RECORDING && /*#__PURE__*/React.createElement("div", {
    className: "record-feedback"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner-grow text-primary spinner",
    role: "status"
  })))));
};